module.exports = "<div class=\"row\">\n  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" >\n    <span class=\"label {{progressTileCtrl.tile.color}}\">\n      {{progressTileCtrl.tile.text}}\n    </span>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/progressTIle/template.html
// module id = 1641
// module chunks = 0